export default function media(min, theme) {
  if (min === 'tablet') min = 'sm';else if (min === 'desktop') min = 'lg';
  return `@media (min-width:${theme.breakpoints.values[min]}px)`;
}